"use strict";
import { BigNumber } from "@ethersproject/bignumber";
import { hexlify, hexValue } from "@ethersproject/bytes";
export class AtomicBatchUnsupportedError extends Error {
}
function isUnsupportedMethod(error, depth = 0) {
  if (!error || typeof error !== "object" || depth > 5) return false;
  if ("code" in error && (error.code === -32601 || error.code === 4200)) return true;
  return "error" in error && isUnsupportedMethod(error.error, depth + 1) || "cause" in error && isUnsupportedMethod(error.cause, depth + 1);
}
export async function submitAtomicBatch({
  provider,
  batchedTxRequests,
  from,
  chainId
}) {
  const calls = batchedTxRequests.map(({ to, data, value }) => ({
    to,
    data: hexlify(data ?? "0x"),
    value: hexValue(BigNumber.from(value ?? 0))
  }));
  let result;
  try {
    result = await provider.send("wallet_sendCalls", [
      { version: "2.0.0", calls, from, chainId: hexValue(chainId), atomicRequired: true }
    ]);
  } catch (error) {
    if (isUnsupportedMethod(error)) {
      throw new AtomicBatchUnsupportedError("Wallet does not support wallet_sendCalls");
    }
    throw error;
  }
  if (!result || typeof result !== "object" || !("id" in result) || typeof result.id !== "string" || !result.id) {
    throw new Error("Wallet returned no v2 batch ID. Check your wallet before retrying the transaction.");
  }
  return result.id;
}
